module.exports = __webpack_public_path__ + "components/logo/static/cityspotters-full-edad0dec15f58377b33b45ea34b29703.svg";